<template>
  <payment-template>
    <base-header
      slot="header"
      :title="$t('operation.denied.title')"
      :language="getLanguage"
    />
    <access-denied
      slot="content"
      :title="$t('no.tickets.left')"
    >
      <simple-button
        slot="action"
        variant="secondary"
        @click="handleRedirect"
      >
        {{ $t('try.again') }}
      </simple-button>
    </access-denied>
  </payment-template>
</template>

<script>
import { mapGetters } from 'vuex';

import SimpleButton from 'molecules/common/SimpleButton';
import AccessDenied from 'molecules/common/AccessDenied';

import BaseHeader from 'organisms/base/BaseHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'NoTicketsLeft',
  components: {
    SimpleButton,
    AccessDenied,
    BaseHeader,
    PaymentTemplate,
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getRouteWithParamsByTransaction',
    ]),
  },
  methods: {
    handleRedirect() {
      this.$router.push(this.getRouteWithParamsByTransaction);
    },
  },
};
</script>
